module.exports = "/dist/montserrat-latin-500.svg?d5c1d1caaceda4f0a32d9d2612632df6";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-500.svg
// module id = 74
// module chunks = 0